import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const firecrawl = defineConnector({
  identifier: "firecrawl",
  name: "Firecrawl",
  tagLine: "Turn websites into AI-ready data",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://api\\.firecrawl\\.dev/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Copy your API key from the [Firecrawl dashboard](https://www.firecrawl.dev/app/api-keys).",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: "fc-...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.firecrawl.dev/v2/team/credit-usage",
  },
});
